import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import FilterPresetsComponent from './components/FilterPresetsComponent';

function FilterPresets() {
  return renderComponent(<FilterPresetsComponent />);
}

export default FilterPresets;
